module.exports = __webpack_public_path__ + "3-63.jpg?bf1fbb73ad52cabd96bac3791c987c6e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-63.jpg
// module id = 145
// module chunks = 0